import { TabsProps } from 'antd/es/tabs';
import { PropsWithChildren } from 'react';

import { StyledTabs } from './tabs.style';

export const Tabs = (props: PropsWithChildren<TabsProps>) => <StyledTabs {...props} />;
